import {useEffect, useState} from "react";
import {Editor} from 'react-draft-wysiwyg';
import {ContentState, convertToRaw, EditorState} from "draft-js";
import PropTypes from "prop-types";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const FieldTextEditor = ({
                             htmlValue, field,
                             placeholder,
                             form: {touched, errors, setFieldValue}
                         }) => {
    const [editorState, _setEditorState] = useState(EditorState.createEmpty());
    const [flag, setFlag] = useState(true);

    useEffect(() => {
        if (htmlValue && flag) {
            const contentBlock = htmlToDraft(htmlValue);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                const editorState = EditorState.createWithContent(contentState);

                _setEditorState(editorState);
                editorState.getSelection().getEndKey();
                setFlag(false);
            }
        }
    }, [htmlValue])

    const onEditorStateChange = (editorState) => {

        const rawData = convertToRaw(editorState.getCurrentContent());
        const html = draftToHtml(rawData);

        _setEditorState(editorState);
        setFieldValue("description", html)
    };

    return (
        <div className={"field FieldTextEditor"}>
            <Editor
                spellCheck
                editorState={editorState}
                wrapperClassName="mb-8 shadow rounded-lg p-2"
                editorClassName="px-4 text-sm"
                onEditorStateChange={onEditorStateChange}
                toolbarClassName="border-0 justify-end"
                placeholder={placeholder}
                toolbar={{
                    options: ['inline', 'list', 'link'],
                    inline: {
                        options: ['bold', 'italic', 'underline'],
                        bold: {className: "border-0"},
                        italic: {className: "border-0"},
                        underline: {className: "border-0"},
                    },
                    list: {
                        unordered: {className: "border-0"},
                        ordered: {className: "border-0"},
                        indent: {className: 'hidden'},
                        outdent: {className: 'hidden'},
                    },
                    link: {
                        link: {className: "border-0"},
                        unlink: {className: "border-0"},
                    },
                    fontSize: {
                        options: [12]
                    },
                    fontFamily: {
                        options: ['Poppins', 'Poppins-Bold', 'Poppins-SemiBold'],
                    },
                }}
            />
        </div>
    )
}

export default FieldTextEditor;


FieldTextEditor.propTypes = {
    htmlValue: PropTypes.string,
    placeholder: PropTypes.string,
    field: PropTypes.object,
    form: PropTypes.object,

}
